export class UserBaseState {
  activeUserId: string;
  activeClientUserId: string;
  activeClientServiceId: string;
}
